import type { PaginatedResponse } from '@scrambl/shared'

/** Bounded sequential pages; publish only a complete successful result. */
export async function readCompletePages<T>(
  read: (page: number) => Promise<PaginatedResponse<T>>,
  signal: AbortSignal,
): Promise<T[]> {
  const rows: T[] = []
  for (let page = 1; ; page++) {
    signal.throwIfAborted()
    const response = await read(page)
    signal.throwIfAborted()
    const meta = response?.meta
    if (
      !Array.isArray(response?.data) ||
      !meta ||
      meta.currentPage !== page ||
      typeof meta.hasNextPage !== 'boolean' ||
      meta.hasNextPage !== page < meta.totalPages ||
      (meta.totalPages === 0 && response.data.length > 0) ||
      !Number.isSafeInteger(meta.totalPages) ||
      meta.totalPages < 0 ||
      (meta.hasNextPage && (!response.data.length || meta.totalPages <= page))
    )
      throw new Error('Member list is unavailable')
    rows.push(...response.data)
    if (!meta.hasNextPage) return rows
  }
}
